import React from 'react';
import {Link, useLocation} from 'react-router-dom';
import i18n from 'i18n';
import Icon from '@/components/icons/Icon';

interface TabConfig {
    key: string;
    title: string;
    icon?: string;
    route: string;
    order?: number;
}

interface TabNavigationMenuProps {
    tabs: TabConfig[];
    activeTab: string;
    onTabChange: (tabKey: string) => void;
    basePath: string;
}

const TabNavigationMenu: React.FC<TabNavigationMenuProps> = ({
    tabs,
    activeTab,
    onTabChange,
    basePath
}) => {
    const location = useLocation();

    const sortedTabs = [...tabs].sort((a, b) => (a.order || 50) - (b.order || 50));

    const containerStyle: React.CSSProperties = {
        padding: 0,
        marginBottom: '1rem',
        borderBottom: '1px solid #dee2e6'
    };

    const navStyle: React.CSSProperties = {
        border: 'none',
        background: 'none',
        margin: 0,
        padding: 0,
        display: 'flex',
        borderBottom: '1px solid #dee2e6'
    };

    const linkStyle: React.CSSProperties = {
        border: 'none',
        borderRadius: 0,
        color: '#495057',
        fontWeight: 500,
        padding: '0.75rem 1.5rem',
        transition: 'all 0.15s ease-in-out',
        backgroundColor: 'transparent',
        textDecoration: 'none',
        display: 'inline-block',
        whiteSpace: 'nowrap',
        borderBottom: '3px solid transparent',
        position: 'relative' as const
    };

    const activeLinkStyle: React.CSSProperties = {
        ...linkStyle,
        color: '#009efb',
        backgroundColor: '#f8f9fa',
        borderBottom: '3px solid #009efb',
        fontWeight: 600
    };

    return (
        <div className="nav-tabs-container" style={containerStyle}>
            <ul className="nav nav-tabs" role="tablist" style={navStyle}>
                {sortedTabs.map(tab => {
                    const isActive = activeTab === tab.key || location.pathname === tab.route;

                    return (
                        <li key={tab.key} className="nav-item">
                            <Link
                                to={tab.route}
                                className={`nav-link ${isActive ? 'active' : ''}`}
                                style={isActive ? activeLinkStyle : linkStyle}
                                onClick={() => onTabChange(tab.key)}
                                data-cy={`tab-${tab.key}`}
                                data-bs-toggle="tab"
                                role="tab"
                            >
                                <span>
                                    {tab.icon && <Icon name={tab.icon} className="mr-2" style={{fontSize: '0.875rem'}} />}
                                    {tab.title}
                                </span>
                            </Link>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default TabNavigationMenu;
